import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import ExpandOutlinedSvg from "@ant-design/icons-svg/es/asn/ExpandOutlined";
import AntdIcon from "../components/AntdIcon";
var ExpandOutlined = function ExpandOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ExpandOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  ExpandOutlined.displayName = 'ExpandOutlined';
}
export default /*#__PURE__*/React.forwardRef(ExpandOutlined);